import { ImportProductDto } from './import';
import { ImportAction, ImportTypes } from './imports.actions';

export type ImportState = Readonly<{
  importProducts: ImportProductDto[] | null;
  errors: any;
}>;

const initialState: ImportState = {
  importProducts: null,
  errors: null
};

const importsReducer = (
  state: ImportState = initialState,
  action: ImportAction
) => {
  switch (action.type) {
    case ImportTypes.SetImportProducts:
      return { ...state, importProducts: action.importProducts };
    case ImportTypes.Failure:
      return { ...state, errors: action.errors };
    default:
      return state;
  }
};

export default importsReducer;
